import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaDownload  } from "react-icons/fa";
import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const DataReportTrendVehXls = (props) => {


    const headerStyle = {fill: {patternType: "solid", fgColor: {rgb: "FFD364"}},}; //a6c4e4
    const headerStyle2 = {font: {bold: true, color: {rgb: "000000"}},};

    const vehicleCount = props.vehCount
    const asset = props.asset && props.asset.replace('&','and')
    const vehClass = props.vehClass;

    const dataVehCount = [];

    const headVehCount = [
        [
            {value: "Year", style: headerStyle},
            {value: "Month", style: headerStyle},
            {value: "0:00-1:00", style: headerStyle},
            {value: "1:00-2:00", style: headerStyle},
            {value: "2:00-3:00", style: headerStyle},
            {value: "3:00-4:00", style: headerStyle},
            {value: "4:00-5:00", style: headerStyle},
            {value: "5:00-6:00", style: headerStyle},
            {value: "6:00-7:00", style: headerStyle},
            {value: "7:00-8:00", style: headerStyle},
            {value: "8:00-9:00", style: headerStyle},
            {value: "9:00-10:00", style: headerStyle},
            {value: "10:00-11:00", style: headerStyle},
            {value: "11:00-12:00", style: headerStyle},
            {value: "12:00-13:00", style: headerStyle},
            {value: "13:00-14:00", style: headerStyle},
            {value: "14:00-15:00", style: headerStyle},
            {value: "15:00-16:00", style: headerStyle},
            {value: "16:00-17:00", style: headerStyle},
            {value: "17:00-18:00", style: headerStyle},
            {value: "18:00-19:00", style: headerStyle},
            {value: "19:00-20:00", style: headerStyle},
            {value: "20:00-21:00", style: headerStyle},
            {value: "21:00-22:00", style: headerStyle},
            {value: "22:00-23:00", style: headerStyle},
            {value: "23:00-24:00", style: headerStyle}
        ],
    ]

    for (let i = 0; i < vehicleCount.length; i++) {
        const veh = vehicleCount[i]
        // for (let j = 0; j < veh.counts.length; j++) {
            dataVehCount.push([
            veh.year,
            veh.date,
            veh.counts[0],
            veh.counts[1],
            veh.counts[2],
            veh.counts[3],
            veh.counts[4],
            veh.counts[5],
            veh.counts[6],
            veh.counts[7],
            veh.counts[8],
            veh.counts[9],
            veh.counts[10],
            veh.counts[11],
            veh.counts[12],
            veh.counts[13],
            veh.counts[14],
            veh.counts[15],
            veh.counts[16],
            veh.counts[17],
            veh.counts[18],
            veh.counts[19],
            veh.counts[20],
            veh.counts[21],
            veh.counts[22],
            veh.counts[23],
            ])
        // }
    }

    const dataSet = [
        {   columns: [asset],
            data: [ [{value: "Vehicle Count: " + vehClass, style: headerStyle2}],...headVehCount,...dataVehCount,"",
                ],
        },
    ]

        return (
            <div>
                <ExcelFile filename={asset} element={<Button size="sm" variant="light"><FaDownload />&nbsp; Download </Button>}>
					<ExcelSheet dataSet={dataSet} name={asset} />
				</ExcelFile>
            </div>
        );
}


export default DataReportTrendVehXls;


